<template>
  <v-card class="sale-success-card" flat>
    <div class="sale-success-card__status">
      <div class="sale-success-card__status-icon">
        <v-icon color="white" size="28">mdi-check-bold</v-icon>
      </div>
    </div>
    <div class="sale-success-card__headline">
      Venta #{{ saleFolioDisplay }} exitosa.
    </div>
    <v-window v-model="windowModel">
      <v-window-item :value="0">
        <div class="sale-success-card__totals">
          <div class="d-flex justify-space-between">
            <span class="text-change-size">Total de la Venta: </span>
            <span class="text-change-size"><strong>{{ total }}</strong></span>
          </div>
          <div v-if="cashChange" class="d-flex justify-space-between align-center">
            <span class="text-change-size">Cambio: </span>
            <span class="sale-success-card__totals-change text-change-size"><strong>{{ cashChange }}</strong></span>
          </div>
        </div>
        <div v-if="invoiceErrorMessage" class="sale-success-card__invoice-warning">
          <div class="sale-success-card__invoice-warning-title">
            La venta se completó, pero la factura no pudo generarse.
          </div>
          <div class="sale-success-card__invoice-warning-message">
            {{ invoiceErrorMessage }}
          </div>
          <div class="sale-success-card__invoice-warning-help">
            Si tienes problemas con el timbrado, realiza la factura en el módulo de
            <strong>Administrador &gt; Facturación</strong>.
          </div>
        </div>
        <v-btn
          block
          large
          color="white"
          class="sale-success-card__action sale-success-card__action--primary"
          :loading="printingTicket"
          @click="$emit('reprint-ticket')"
        >
          <v-icon left small>mdi-printer</v-icon>
          Imprimir Ticket de Venta
        </v-btn>
        <div v-if="invoiceResponse" class="sale-success-card__invoice-box">
          <v-btn
            block
            large
            color="white"
            class="sale-success-card__action sale-success-card__action--primary"
            @click="$emit('download-invoice')"
          >
            Descargar Factura (XML / PDF)
          </v-btn>
        </div>
        <div v-if="showCollectionTicket" class="sale-success-card__legal-box">
          <div class="sale-success-card__legal-title">
            Documento Legal Requerido
          </div>
          <v-btn
            color="primary"
            class="sale-success-card__legal-action"
            depressed
            :disabled="!canOpenCollectionTicket"
            @click="openCollectionTicketPreview"
          >
            <v-icon left small color="white">mdi-printer</v-icon>
            Imprimir Vale de Resguardo
          </v-btn>
        </div>
        <v-btn
          block
          large
          color="white"
          class="sale-success-card__action"
          @click="showEmailClientWindow"
        >
          <v-icon left small>mdi-email</v-icon>
          Envíar Copia Digital (Correo)
        </v-btn>
      </v-window-item>
      <v-window-item :value="1">
        <span class="text-title-1 font-weight-bold ">Envíar Copia Digital (Correo)</span>
        <div class="my-4">
          <v-text-field
            v-model="name"
            color="secondary"
            text
            hide-details
            class="mb-4"
            label="Buscar por nombre">
          </v-text-field>
          <div v-if="showSimilarClients()" class="mt-2">
            <h5>Clientes con nombre similar:</h5>
            <span v-for="(item, index) in similarClients" :key="index">
              <v-chip
                color="primary"
                class="ma-2"
                outlined
                @click="onSimilarClientClicked(item)"
              >
                <span>{{ item.name }}</span>
                <span v-if="item.rfc && item.rfc != ''">&nbsp;-&nbsp;{{ item.rfc }}</span>
              </v-chip>
            </span>
          </div>
          <v-divider></v-divider>
          <v-text-field
            v-model="email"
            outlined
            label="Enviar copia digital a esta dirección de correo">
          </v-text-field>
          <v-text-field v-if="false" label="Teléfono"></v-text-field>
          <v-alert
            :value="emailResponse"
            border="left"
            :color="emailSuccess ? 'green' : 'red'"
            dense
            text
            :type="emailSuccess ? 'success' : 'error'"
          >
            <span v-if="emailSuccess">Correo enviado correctamente</span>
            <span v-else>No se pudo enviar el correo</span>
          </v-alert>
          <div class="d-flex justify-space-between">
            <v-btn
              text
              @click="windowModel = 0"
            >Regresar</v-btn>
            <v-btn
              large
              color="primary"
              @click="sendEmail"
              :rules="[validateEmail]"
              :disabled="!validateEmail(email)"
              :loading="sendingEmail"
            >
              Enviar
            </v-btn>
          </div>
        </div>
      </v-window-item>
    </v-window>
    <div class="d-flex justify-center">
      <v-btn
        large
        color="primary"
        @click="closeDialog"
      >
        Listo - Nueva Venta
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import ClientService from '../../services/ClientService';
import PurchaseOrderService from '../../services/PurchaseOrderService';
import { FormUtils } from '../../utils/FormUtils';

export default {
  name: 'sale-success-actions',
  props: {
    saleId: {
      type: [Number, String],
      default: null,
    },
    saleFolio: {
      type: [Number, String],
      default: null,
    },
    clientEmail: {
      type: String,
      default: '',
    },
    total: {
      type: String,
      default: null,
    },
    cashChange: {
      type: String,
      default: null,
    },
    showCollectionTicket: {
      type: Boolean,
      default: false,
    },
    printingTicket: {
      type: Boolean,
      default: false,
    },
    invoiceResponse: {
      type: Object,
      default: null,
    },
    invoiceErrorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      name: null,
      email: null,
      windowModel: 0,
      nameLookupTimeout: null,
      similarClients: [],
      hasManySimilarClients: false,
      emailResponse: false,
      emailSuccess: false,
      sendingEmail: false,
    };
  },
  computed: {
    disableSendEmail() {
      return !this.email;
    },
    saleFolioDisplay() {
      return this.saleFolio == null || this.saleFolio === '' ? '----' : this.saleFolio;
    },
    canOpenCollectionTicket() {
      return this.saleFolio != null && this.saleFolio !== '';
    },
  },
  watch: {
    name() {
      this.delayedNameLookup();
    },
  },
  methods: {
    openCollectionTicketPreview() {
      if (!this.canOpenCollectionTicket) return;

      const routeData = this.$router.resolve({
        name: 'resguardo-vale-ticket',
        params: { folio: String(this.saleFolio), mode: 'todas' },
      });

      const openedTab = window.open(routeData.href, '_blank');

      if (!openedTab) {
        this.$router.push({
          name: 'resguardo-vale-ticket',
          params: { folio: String(this.saleFolio) },
        });
      }
    },
    showEmailClientWindow() {
      this.windowModel = 1;
    },
    delayedNameLookup() {
      clearTimeout(this.nameLookupTimeout);
      this.nameLookupTimeout = setTimeout(() => {
        if (this.name && this.name.length > 3) {
          ClientService.getSimilarClients(this.name).then((data) => {
            this.similarClients = data;
          });
        } else {
          this.similarClients = [];
        }
      }, 500);
    },
    showSimilarClients() {
      const hasResults = this.similarClients.length > 0;
      if (!hasResults) {
        return false;
      }
      const hasManyResults = this.similarClients.length > 5;
      if (hasManyResults) {
        this.hasManySimilarClients = true;
        return false;
      }
      this.hasManySimilarClients = false;
      return true;
    },
    onSimilarClientClicked(client) {
      if (client.contactInfo && client.contactInfo.length > 0) {
        for (let i = 0; i < client.contactInfo.length; i += 1) {
          const contact = client.contactInfo[i];
          if (contact.email) {
            this.email = contact.email;
            break;
          }
        }
      }
    },
    trimMax(value, max = 100) {
      return FormUtils.trimMax(value, max);
    },
    validateEmail(value) {
      const email = this.trimMax(value, 100);
      if (!email) return false;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        return false;
      }
      return true;
    },
    sendEmail() {
      this.sendingEmail = true;
      PurchaseOrderService.sendEmail(this.saleId, this.saleFolio, this.email).then((response) => {
        this.sendingEmail = false;
        this.emailResponse = true;
        if (response.error) {
          this.emailSuccess = false;
          console.error(response.error);
        } else {
          this.emailSuccess = true;
          this.name = '';
          this.email = '';
          this.similarClients = [];
        }
      });
    },
    closeDialog() {
      this.emailSuccess = false;
      this.emailResponse = false;
      this.email = '';
      this.name = '';
      this.similarClients = [];
      this.hasManySimilarClients = false;
      this.sendingEmail = false;
      this.windowModel = 0;
      this.$emit('close');
    },
  },
  mounted() {
    this.email = this.clientEmail;
  },
};
</script>

<style lang="less" scoped>
.sale-success-card {
  border: 2px solid #8f96a3;
  border-radius: 24px;
  padding: 40px 28px 28px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f8fc 100%);
  box-shadow: 0 18px 40px rgba(23, 32, 63, 0.08);
}

.sale-success-card__status {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
}

.sale-success-card__status-icon {
  width: 54px;
  height: 54px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #8ceb1b 0%, #61da14 100%);
  box-shadow: 0 10px 24px rgba(100, 221, 23, 0.35);
}

.sale-success-card__headline {
  margin-bottom: 22px;
  text-align: center;
  color: #2d3656;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
}

.sale-success-card__totals {
  text-align: end;
  font-size: 18px;
  margin-bottom: 22px;
  padding: 0px 8px;
  border-radius: 16px;
}

.sale-success-card__totals-change {
  font-size: 22px;
  color: #30ad4b;
}

.sale-success-card__invoice-warning {
  margin-bottom: 22px;
  padding: 16px 18px;
  border-radius: 16px;
  background: #fff8e6;
  border: 1px solid #f5d08a;
  color: #9a5b00;
}

.sale-success-card__invoice-warning-title {
  margin-bottom: 8px;
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
}

.sale-success-card__invoice-warning-message {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.4;
  word-break: break-word;
}

.sale-success-card__invoice-warning-help {
  font-size: 14px;
  line-height: 1.4;
}

.sale-success-card__action {
  margin-bottom: 18px;
  min-height: 54px !important;
  border-radius: 14px;
  border-color: #2c467f !important;
  color: #2d3656 !important;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}

.sale-success-card__action--primary {
  border: 1px solid #e5e8f2 !important;
  box-shadow: 0 8px 18px rgba(28, 40, 82, 0.08);
}

.sale-success-card__legal-box {
  margin-bottom: 22px;
  padding: 14px 18px 18px;
  border: 2px solid #3b4d84;
  border-radius: 14px;
  text-align: center;
}

.sale-success-card__legal-title {
  margin-bottom: 10px;
  color: #20356b;
  font-size: 13px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.sale-success-card__legal-action {
  min-height: 40px !important;
  border-radius: 10px;
  text-transform: none;
  font-weight: 700;
  letter-spacing: 0;
}

.sale-success-card__done {
  margin-top: 10px;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: none;
}

.text-change-size {
  font-size: 24px;
}

@media (max-width: 600px) {
  .sale-success-card {
    padding: 28px 18px 20px;
    border-radius: 18px;
  }

  .sale-success-card__headline {
    font-size: 22px;
  }
}
</style>
